import { render } from "./TraineeChooseTaskAssessmentModal.vue?vue&type=template&id=667b2a25&scoped=true"
import script from "./TraineeChooseTaskAssessmentModal.vue?vue&type=script&lang=js"
export * from "./TraineeChooseTaskAssessmentModal.vue?vue&type=script&lang=js"

import "./TraineeChooseTaskAssessmentModal.vue?vue&type=style&index=0&id=667b2a25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667b2a25"]])

export default __exports__